import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Langs from "../../../app/lang/langs";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import { deletePlanning, getPlanning } from "../planningSlice";
import moment from "moment";

export function MobileDeleteModal({ show, onHide }) {
  const dispatch = useDispatch();

  const collabs = useSelector((state) => state.collabs.list);
  const selectedView = useSelector((state) => state.planning.selectedView);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId);
  }

  function handleDeletePlanning() {
    let range = "month";
    if (selectedView == "WEEKLY") {
      range = "week";
    }
    let from = moment(selectedDate).startOf(range).format("x");
    let to = moment(selectedDate).endOf(range).format("x");

    if (from && to) {
      let params = {
        teamIds: selectedTeamsIds.filter((id) => isManager(id)),
        from: from,
        to: to,
      };
      dispatch(deletePlanning(params)).then((response) => {
        if (response["payload"]["responseData"]["status"] == 1) {
          loadPlanning();
        }
        if (response["payload"]["responseData"]["status"] == 4) {
          showErrorToast(response["payload"]["responseData"]["message"]);
        }
        if (response["payload"]["responseError"]) {
          showErrorToast();
        }
      });
    }
    onHide();
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="xs"
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          mx: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pb: 1,
        }}
      >
        <DeleteForeverIcon sx={{ color: "#d32f2f", fontSize: 28 }} />
        <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
          <Langs str="Delete planning" />
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ py: 1 }}>
          <Langs str="DELETE_PLANNING_VALIDATION_MSG" />
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onHide}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            color: "text.secondary",
            borderColor: "divider",
          }}
        >
          <Langs str="CANCEL" />
        </Button>
        <Button
          variant="contained"
          onClick={handleDeletePlanning}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#d32f2f",
            "&:hover": { backgroundColor: "#b71c1c" },
            "&:active": { transform: "scale(0.97)" },
          }}
        >
          <Langs str="Delete" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
